const API_BASE_URL_DEVELOPMENT = "https://localhost:7021";
const API_BASE_URL_PRODUCTION = "https://appname.azurewebsites.net";

const ENDPOINTS = {
  GET_ALL_USERS: "users",
  GET_USERS_BY_USERNAME: "users",
  CREATE_USER: "users",
  UPDATE_USER: "users",
  DELETE_USER_BY_USERNAME: "users",
  CREATE_USER_LOGIN: "userlogin",
  CREATE_VOTER:"voters",
  CREATE_NOMINEE:"nominees",
  GET_ALL_VOTERS: "voters",
  GET_ALL_NOMINEES: "nominees",
};

const development = {
  API_URL_GET_ALL_USERS: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_ALL_USERS}`,
  API_URL_GET_ALL_VOTERS: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_ALL_VOTERS}`,
  API_URL_GET_ALL_NOMINEES: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_ALL_NOMINEES}`,
  API_URL_GET_USERS_BY_USERNAME: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_USERS_BY_USERNAME}`,
  API_URL_CREATE_USER: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.CREATE_USER}`,
  API_URL_CREATE_VOTER: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.CREATE_VOTER}`,
  API_URL_CREATE_NOMINEE: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.CREATE_NOMINEE}`,
  API_URL_UPDATE_USER: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.UPDATE_USER}`,
  API_URL_DELETE_USER_BY_USERNAME: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.DELETE_USER_BY_USERNAME}`,
  API_URL_CREATE_USER_LOGIN: `${API_BASE_URL_DEVELOPMENT}/${ENDPOINTS.CREATE_USER_LOGIN}`,
};

const production = {
   API_URL_GET_ALL_USERS: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.GET_ALL_USERS}`,
  API_URL_GET_ALL_VOTERS: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.GET_ALL_VOTERS}`,
 API_URL_GET_ALL_NOMINEES: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.GET_ALL_NOMINEES}`,
  API_URL_GET_USERS_BY_USERNAME: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.GET_USERS_BY_USERNAME}`,
  API_URL_CREATE_USER: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.CREATE_USER}`,
  API_URL_UPDATE_USER: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.UPDATE_USER}`,
  API_URL_CREATE_VOTER: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.CREATE_VOTER}`,
  API_URL_CREATE_NOMINEE: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.CREATE_NOMINEE}`,
  API_URL_DELETE_USER_BY_USERNAME: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.DELETE_USER_BY_USERNAME}`,
  API_URL_CREATE_USER_LOGIN: `${API_BASE_URL_PRODUCTION}/${ENDPOINTS.CREATE_USER_LOGIN}`,
  
};

const Constants =
  process.env.NODE_ENV === `development` ? development : production;

export default Constants;
